const Wrapper = ({ children, headerNode, link }) => {
    return (
        <div className="main-container2">
            {link && headerNode !== "Login" &&
                <div className="top">
                    {<p className="account-text2">Don't have an account <br />  <a href={link} target="blank">Register here !</a></p>}
                </div>
            }

            <div className="box">
                <div className="emlyLogoMb">
                    <img src={require('./assets/ELogo.png')} />
                </div>
                <div className="main">
                    <p className="title">{headerNode}</p>
                    {children}
                </div>
            </div>
            <a href="https://emlylabs.com/privacy-policy/" target="_blank" className="em-link privacy">
                Privacy Policy
            </a>
        </div>
    )
}

export default Wrapper